import { render, staticRenderFns } from "./PayrollBusinessEmployees.vue?vue&type=template&id=f5868b2c&scoped=true&"
import script from "./PayrollBusinessEmployees.vue?vue&type=script&lang=ts&"
export * from "./PayrollBusinessEmployees.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollBusinessEmployees.vue?vue&type=style&index=0&id=f5868b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5868b2c",
  null
  
)

export default component.exports